<template>
  <div v-resize="onResize">
    <div ref="topDiv" v-mutate="onResize">
      <slot name="top" />
    </div>
    <div ref="contentDiv" :style="'height:' + contentHeight + 'px'">
      <slot />
    </div>
    <div ref="bottomDiv" v-mutate="onResize">
      <slot name="bottom" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DockLayout",
  data() {
    return {
      contentHeight: 0
    };
  },
  methods: {
    onResize() {
      this.contentHeight = window.innerHeight
        - this.$refs.topDiv.getBoundingClientRect().height
        - this.$refs.bottomDiv.getBoundingClientRect().height;
    }
  }
};
</script>

<style scoped>
</style>